import React, { useState } from "react";
import "./CreateCorporateStyles.css";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import CircularProgress from "@mui/material/CircularProgress";

const CreateCorporateComponent = (props) => {
  const [domainInput, setDomainInput] = useState("");

  const handleBusinessNameChange = (e) => {
    // Limit to 50 characters
    if (e.target.value.length <= 50) {
      const event = {
        target: {
          name: "name",
          value: e.target.value
        }
      };
      props.handleChangeCorporate(event);
    }
  };

  const handleDomainInputChange = (e) => {
    // Limit to 50 characters
    if (e.target.value.length <= 20) {
      setDomainInput(e.target.value);
    }
  };

  const addDomain = () => {
    if (domainInput.trim()) {
      const event = {
        target: {
          name: "domain",
          value: domainInput.trim()
        }
      };
      props.handleChangeCorporate(event);
      setDomainInput("");
    }
  };

  const removeDomain = (index) => {
    const newDomains = [...props.createCorporateData.domains];
    newDomains.splice(index, 1);
    
    props.setCreateCorporateData({
      ...props.createCorporateData,
      domains: newDomains
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && domainInput.trim()) {
      e.preventDefault();
      addDomain();
    }
  };

  const clearBusinessName = () => {
    const event = {
      target: {
        name: "name",
        value: ""
      }
    };
    props.handleChangeCorporate(event);
  };

  const clearDomainInput = () => {
    setDomainInput("");
  };

  return (
    <div className="corporate-create-container">
      <div className="corporate-create-card">
        <Box className="corporate-form-box">
          <h2 className="corporate-form-title">Corporate Details</h2>
          
          <p className="corporate-form-subtitle">
            Fill in the details for the new corporate entity. You can add more for bulk creations.
          </p>
          
          <div className="corporate-form-fields">
            <div className="corporate-field-group">
              <label className="corporate-field-label">
                Business Name  <span style={{color:"red"}}> *</span>
                <span className="character-count">
                  {props.createCorporateData.name?.length || 0}/50
                </span>
              </label>
              <div className="input-with-clear">
                <TextField
                  className="corporate-text-field"
                  fullWidth
                  placeholder="Enter business name"
                  value={props.createCorporateData.name || ""}
                  onChange={handleBusinessNameChange}
                  variant="outlined"
                  size="medium"
                  disabled={props.loading}
                  inputProps={{
                    maxLength: 50
                  }}
                />
                {props.createCorporateData.name && (
                  <IconButton
                    className="clear-input-btn"
                    onClick={clearBusinessName}
                    size="small"
                    disabled={props.loading}
                  >
                    <CloseIcon fontSize="small" />
                  </IconButton>
                )}
              </div>
            </div>

            <div className="corporate-field-group">
              <label className="corporate-field-label">
                Business Domains <span style={{color:"red"}}> *</span>
                <span className="character-count">
                  {domainInput.length}/20
                </span>
              </label>
              
              <div className="domain-input-container">
                <div className="input-with-clear">
                  <TextField
                    className="corporate-text-field domain-input"
                    fullWidth
                    placeholder="example.com"
                    value={domainInput}
                    onChange={handleDomainInputChange}
                    onKeyDown={handleKeyDown}
                    variant="outlined"
                    size="medium"
                    disabled={props.loading}
                    inputProps={{
                      maxLength: 50
                    }}
                  />
                  {domainInput && (
                    <IconButton
                      className="clear-input-btn"
                      onClick={clearDomainInput}
                      size="small"
                      disabled={props.loading}
                    >
                      <CloseIcon fontSize="small" />
                    </IconButton>
                  )}
                </div>
                <Button
                  className="add-domain-btn"
                  startIcon={<AddIcon />}
                  onClick={addDomain}
                  variant="outlined"
                  size="medium"
                  disabled={!domainInput.trim() || props.loading}
                >
                  Add
                </Button>
              </div>
              
              <div className="domain-chips-container">
                {props.createCorporateData.domains && 
                 props.createCorporateData.domains.map((domainObj, index) => (
                  domainObj.domain && (
                    <Chip
                      key={index}
                      label={domainObj.domain}
                      onDelete={() => removeDomain(index)}
                      deleteIcon={<CloseIcon />}
                      className="domain-chip"
                      variant="outlined"
                    />
                  )
                ))}
              </div>
            </div>
          </div>

          {/* Loading Indicator */}
          {props.loading && (
            <div className="corporate-loading-indicator">
              <CircularProgress size={24} />
              <span>Creating corporate...</span>
            </div>
          )}
        </Box>
      </div>
    </div>
  );
};

export default CreateCorporateComponent;